import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const Languages = ['sr_cyr', 'sr_lat', 'en_gb'];

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    fallbackLng: 'sr_cyr',
    lng: window.localStorage.getItem('i18nextLng') || 'sr_cyr',
    debug: false, // printing infos in console
    interpolation: {
        escapeValue: false
    },
    whitelist: Languages,
})

export default i18n;